module.exports = __webpack_public_path__ + "img/hint.80c7b932.svg";